// Greenhold component prototype: <CreatorEarningsTicker>. Story 1.26.
//
// Mounted at /prototype/creator-earnings-ticker (no guard) per UX-DR
// Component Implementation Strategy line 1651 — the team's MVP-Storybook
// substitute. Shows three states side-by-side for visual review:
//   * default (zero values, no empty-state copy)
//   * empty (zero values + empty-state copy below)
//   * loading (skeleton placeholders for each numeric slot)

import { CreatorEarningsTicker } from "@greenhold/components";

export function CreatorEarningsTickerPrototype() {
  return (
    <main className="min-h-screen bg-brand-paper-100 text-brand-forest-900 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-heading font-bold mb-2">
          &lt;CreatorEarningsTicker&gt; prototype
        </h1>
        <p className="opacity-80 mb-8">
          Story 1.26 — three rendered states for visual verification of the
          screenshot-able structural artifact (UX-DR21 + PRD §Tama journey).
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <section>
            <h2 className="text-sm uppercase tracking-wider font-mono opacity-70 mb-3">
              default — zero values
            </h2>
            <CreatorEarningsTicker
              state="default"
              cumulativeEurCents={0}
              currentMonthEurCents={0}
              primaryEurCents={0}
              resaleEurCents={0}
              holdersCount={null}
              sparkline4w={[]}
            />
            <p className="text-xs opacity-60 mt-2">
              Empty-state copy renders because cumulative is 0.
            </p>
          </section>

          <section>
            <h2 className="text-sm uppercase tracking-wider font-mono opacity-70 mb-3">
              empty — explicit
            </h2>
            <CreatorEarningsTicker
              state="empty"
              cumulativeEurCents={0}
              currentMonthEurCents={0}
              primaryEurCents={0}
              resaleEurCents={0}
              holdersCount={null}
              sparkline4w={[]}
            />
            <p className="text-xs opacity-60 mt-2">
              Same render as default-at-zero; visual structure identical.
            </p>
          </section>

          <section>
            <h2 className="text-sm uppercase tracking-wider font-mono opacity-70 mb-3">
              loading — skeletons
            </h2>
            <CreatorEarningsTicker
              state="loading"
              cumulativeEurCents={0}
              currentMonthEurCents={0}
              primaryEurCents={0}
              resaleEurCents={0}
              holdersCount={null}
              sparkline4w={[]}
            />
            <p className="text-xs opacity-60 mt-2">
              Numeric slots become pulsing placeholders; sparkline keeps
              flat-line at zero.
            </p>
          </section>
        </div>

        <hr className="border-brand-forest-200 my-10" />

        <section>
          <h2 className="text-sm uppercase tracking-wider font-mono opacity-70 mb-3">
            Hypothetical future-state preview (UX-DR21 example values)
          </h2>
          <div className="max-w-md">
            <CreatorEarningsTicker
              state="default"
              creator="Tama Streamer"
              cumulativeEurCents={28000}
              currentMonthEurCents={4200}
              primaryEurCents={19000}
              resaleEurCents={9000}
              holdersCount={87}
              sparkline4w={[1200, 1800, 900, 4200]}
            />
            <p className="text-xs opacity-60 mt-2">
              Not wired at v1 — first non-zero numbers ship when Epic 3/5
              primary + resale ledger entries flow.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
